import { render, staticRenderFns } from "./CustomAppBar.vue?vue&type=template&id=9436042e&scoped=true"
import script from "./CustomAppBar.vue?vue&type=script&lang=js"
export * from "./CustomAppBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9436042e",
  null
  
)

export default component.exports